import React, {
  useEffect,
  useState,
  FC,
  useMemo,
  useCallback,
  useRef,
} from "react";
import ProjectPageShell from "../shared/ProjectPageShell";
import { Icon } from "../../../components/Component";

import {
  Table,
  InputNumber,
  Drawer,
  Tabs,
  Input,
  Badge,
  DatePicker,
  Modal,
  Popover,
  Select,
  Button as AntButton,
} from "antd";
import { Button, UncontrolledDropdown, DropdownToggle } from "reactstrap";
import { ColumnsType } from "antd/lib/table";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { updateMenuData } from "../../../store/slices/misc/menuData";
import TopMenu from "../../../route/topMenu";
import SkeletonTable, {
  SkeletonTableColumnsType,
} from "../../../utils/skeleton-templates/table";
import { SearchOutlined, EyeOutlined } from "@ant-design/icons";
import { ReactComponent as TaskIcon } from "../../../assets/icons/TaskIcon.svg";
import FormMultiSelect from "../../form-components/MultiSelectComponent";
import FormSelect from "../../form-components/SelectComponent";
import FormDatePicker from "../../form-components/DatePicker";
import dayjs from "dayjs";
import { FormProvider, useForm } from "react-hook-form";

import { buyerApis } from "../../../api/buyer";
import { documentApis } from "../../../api/Documents";
import contractorsApis from "../../../api/master/contractors";
import Swal from "sweetalert2";
import TrackIndentList from "./TrackIndentList";
import { useWbsName } from "../shared/useWbsCodes";

// ShowAddressPopOver Component
const ShowAddressPopOver: React.FC<{
  id: string | number;
  matchKey: string;
  options: any[];
  text: string;
}> = ({ id, matchKey, options, text }) => {
  const selectedOption = options.find((option) => option[matchKey] == id);

  if (!selectedOption) {
    return <div>No address details found</div>;
  }

  return (
    <div style={{ maxWidth: "300px" }}>
      <div style={{ marginBottom: "8px" }}>
        <strong>{text}:</strong> {selectedOption.deliveryLocationName || "N/A"}
      </div>
      {selectedOption.address && (
        <div style={{ marginBottom: "8px" }}>
          <strong>Address:</strong> {selectedOption.address}
        </div>
      )}
      {selectedOption.city && (
        <div style={{ marginBottom: "8px" }}>
          <strong>City:</strong> {selectedOption.city}
        </div>
      )}
      {selectedOption.state && (
        <div style={{ marginBottom: "8px" }}>
          <strong>State:</strong> {selectedOption.state}
        </div>
      )}
      {selectedOption.country && (
        <div style={{ marginBottom: "8px" }}>
          <strong>Country:</strong> {selectedOption.country}
        </div>
      )}
      {selectedOption.pincode && (
        <div style={{ marginBottom: "8px" }}>
          <strong>Pincode:</strong> {selectedOption.pincode}
        </div>
      )}
    </div>
  );
};

type TaskRow = {
  key: string;
  task: string;
  requiredQuantity: number;
  quantityToRequest: number | string;
  inProgressQuantity: number;
  uom: string;
  taskBoqLineId?: number;
  underPriceEnquiryQuantity?: number;
  releasedOrderQuantity?: number;
  siteStructureUnitId?: number | null;
  siteStructureUnitName?: string | null;
  floorNo?: string | null;
  siteStructureSubUnitId?: number | null;
  locationId?: number | null;
};

type MaterialRow = {
  key: string;
  material: string;
  requiredQuantity: number;
  stockAvailable: number;
  quantityToRequest: number | string;
  inProgressQuantity: number;
  uom: string;
  materialId?: number;
  categoryId?: number;
  categoryName?: string;
  uomId?: number;
  underPriceEnquiryQuantity?: number;
  releasedOrderQuantity?: number;
  tasks?: TaskRow[];
};

const defaultData: MaterialRow[] = [];

const InventoryAnalysis: FC = () => {
  // CSS for date link hover effects
  React.useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      .date-link-hover:hover {
        background-color: #f0f8ff !important;
        color: #0056b3 !important;
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(0, 86, 179, 0.1);
      }
      
      .spin {
        animation: spin 1s linear infinite;
      }
      
      @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);
  const dispatch = useDispatch();
  const wbsName = useWbsName();
  const location = useLocation();
  const [rows, setRows] = useState<MaterialRow[]>(defaultData);
  const [previewModal, setPreviewModal] = useState(false);
  const [inputValues, setInputValues] = useState<
    Record<string, number | string>
  >({});
  const [focusedInput, setFocusedInput] = useState<string | null>(null);
  const [debouncedValues, setDebouncedValues] = useState<
    Record<string, number | string>
  >({});
  const [displayRows, setDisplayRows] = useState<MaterialRow[]>(defaultData);
  const [isTyping, setIsTyping] = useState(false);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [filtersModal, setFiltersModal] = useState(false);
  const [customDateRange, setCustomDateRange] = useState<any>(null);
  const [phaseFilterData, setPhaseFilterData] = useState<any[]>([]);
  const [activityFilterData, setActivityFilterData] = useState<any[]>([]);
  const [taskStatusFilterData, setTaskStatusFilterData] = useState<any[]>([]);
  const [filteredData, setFilteredData] = useState<any>({});

  const [isLoading, setIsLoading] = useState(false);
  const [hasInitialDataLoaded, setHasInitialDataLoaded] = useState(false);
  const [hasResetBeenClicked, setHasResetBeenClicked] = useState(false);
  const [hasFilterDataBeenFetched, setHasFilterDataBeenFetched] =
    useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState<string | null>(
    null
  );
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [hasFiltersApplied, setHasFiltersApplied] = useState(false);
  const [activeTab, setActiveTab] = useState<string>("forecast");
  const [prModal, setPrModal] = useState(false);
  const [siteUsers, setSiteUsers] = useState<any[]>([]);
  const [siteAddresses, setSiteAddresses] = useState<any[]>([]);
  const [siteAddressesList, setSiteAddressesList] = useState<any[]>([]);
  const [sequenceData, setSequenceData] = useState<string[]>([]);
  const [prFormData, setPrFormData] = useState({
    requestedBy: "",
    deliveryAddress: "",
    prSequence: "",
    needByDate: "",
  });
  const [isPrLoading, setIsPrLoading] = useState(false);
  const [prError, setPrError] = useState<string>("");
  const [contractorOptions, setContractorOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const [selectedContractorId, setSelectedContractorId] = useState<
    string | undefined
  >(undefined);
  const [siteSegmentLevel, setSiteSegmentLevel] = useState<string | null>(null);
  const inputRefs = useRef<Record<string, any>>({});
  const { data: SideNavCollapse } = useSelector(
    (state: any) => state.SideNavCollapseStatus
  );
  const [screenSize, setScreenSize] = useState(0);
  const {
    projectName,
    id: projectId,
    extra: { siteName: projectSiteName, siteId: projectSiteId } = {} as any,
  } = location.state || {};

  const methods = useForm({
    mode: "onSubmit",
    defaultValues: {
      phaseIds: [] as string[],
      activityIds: [] as string[],
      taskStatus: [] as string[],
      showOnlyShortageMaterials: "",
      dateRange: null as any,
    },
    resolver: (values) => {
      const errors: any = {};

      // Only date range is required
      if (!customDateRange || !customDateRange[0] || !customDateRange[1]) {
        errors.dateRange = { message: "This field is required" };
      }

      return {
        values,
        errors: Object.keys(errors).length > 0 ? errors : {},
      };
    },
  });

  // Watch form values to ensure they're properly synchronized
  const watchedPhaseIds = methods.watch("phaseIds");
  const watchedActivityIds = methods.watch("activityIds");

  const {
    formState: { errors, dirtyFields },
  } = methods;

  // Helper function to check if a value represents a meaningful change
  const hasValidChanges = useCallback(() => {
    return Object.entries(inputValues).some(([key, value]) => {
      return (
        value !== "" && value !== 0 && value !== null && value !== undefined
      );
    });
  }, [inputValues]);

  // Helper function to calculate current filter count
  const calculateFilterCount = useCallback(() => {
    let count = 0;

    // Count phase filters
    if (filteredData.phaseIds && filteredData.phaseIds.length > 0) {
      count++;
    }

    // Count activity filters
    if (filteredData.activityIds && filteredData.activityIds.length > 0) {
      count++;
    }

    // Count task status filters
    if (filteredData.taskStatus && filteredData.taskStatus.length > 0) {
      count++;
    }

    // Count show only shortage materials filter
    if (filteredData.showOnlyShortageMaterials) {
      count++;
    }

    // Count date range filter
    if (filteredData.startDate && filteredData.endDate) {
      count++;
    } else if (customDateRange && customDateRange[0] && customDateRange[1]) {
      count++; // Count default date range if no custom selection
    }

    return count;
  }, [filteredData, customDateRange]);

  const handleQtyChange = useCallback(
    (materialKey: string, taskKey: string, value: number | string | null) => {
      const finalValue =
        value === null || value === undefined || value === ""
          ? 0
          : Number(value);

      setRows((prev) =>
        prev.map((m) => {
          if (m.key !== materialKey) return m;

          const tasks = (m.tasks || []).map((t) =>
            t.key === taskKey
              ? {
                  ...t,
                  quantityToRequest: Math.max(
                    0,
                    Math.min(
                      Number.isFinite(finalValue) ? finalValue : 0,
                      t.requiredQuantity
                    )
                  ),
                }
              : t
          );

          const totalQuantityToRequest = tasks.reduce(
            (sum, t) => sum + (Number(t.quantityToRequest) || 0),
            0
          );

          return {
            ...m,
            tasks,
            quantityToRequest: totalQuantityToRequest,
          };
        })
      );

      setDisplayRows((prev) =>
        prev.map((m) => {
          if (m.key !== materialKey) return m;

          const tasks = (m.tasks || []).map((t) =>
            t.key === taskKey
              ? {
                  ...t,
                  quantityToRequest: Math.max(0, finalValue), // Remove Math.min restriction
                }
              : t
          );

          const totalQuantityToRequest = tasks.reduce(
            (sum, t) => sum + (Number(t.quantityToRequest) || 0),
            0
          );

          return {
            ...m,
            tasks,
            quantityToRequest: totalQuantityToRequest,
          };
        })
      );
    },
    []
  );

  const handleInputChange = useCallback(
    (taskKey: string, value: number | string | null) => {
      const finalValue =
        value === null || value === undefined || value === "" ? "" : value;

      setIsTyping(true);

      setInputValues((prev) => ({
        ...prev,
        [taskKey]: finalValue,
      }));

      const timeoutId = setTimeout(() => {
        setDebouncedValues((prev) => ({
          ...prev,
          [taskKey]: finalValue,
        }));
        setIsTyping(false);
      }, 500);

      return () => clearTimeout(timeoutId);
    },
    []
  );

  useEffect(() => {
    if (Object.keys(debouncedValues).length === 0) return;

    Object.entries(debouncedValues).forEach(([taskKey, value]) => {
      const parentMaterial = rows.find((material) =>
        material.tasks?.some((task) => task.key === taskKey)
      );
      if (parentMaterial) {
        handleQtyChange(parentMaterial.key, taskKey, value);
      }
    });

    setDebouncedValues({});
  }, [debouncedValues, rows, handleQtyChange]);

  useEffect(() => {
    return () => {
      setDebouncedValues({});
    };
  }, []);

  const handleInputFocus = useCallback((taskKey: string) => {
    setFocusedInput(taskKey);
    const inputElement = inputRefs.current[taskKey];
    if (inputElement) {
      setTimeout(() => {
        inputElement.focus();
        const length = inputElement.value?.length || 0;
        inputElement.setSelectionRange(length, length);
      }, 0);
    }
  }, []);

  const handleInputBlur = useCallback((taskKey: string) => {
    setFocusedInput(null);
  }, []);

  // Function to get quantity difference message and styling.
  // Compares (stockAvailable + quantityToRequest) to requiredQty; no message when equal.
  const getQuantityInfo = useCallback(
    (
      quantityToRequest: number | string,
      requiredQty: number,
      stockAvailable: number | string = 0
    ) => {
      if (
        quantityToRequest === "" ||
        quantityToRequest === null ||
        quantityToRequest === undefined
      ) {
        return null;
      }
      const stock = Number(stockAvailable) || 0;
      const totalAvailable = stock + Number(quantityToRequest);
      const difference = totalAvailable - requiredQty;

      if (difference > 0) {
        return {
          message: `Exceeds required quantity by ${difference}`,
          color: "#dc3545",
          tagColor: "error",
          icon: "⚠️",
        };
      } else if (difference < 0) {
        return {
          message: `Short of required quantity by ${Math.abs(difference)}`,
          color: "#ffc107",
          tagColor: "warning",
          icon: "📉",
        };
      }
      // Stock Available + Quantity to Request = Required Quantity: no message
      return null;
    },
    []
  );

  const viewChange = () => {
    setScreenSize(window.innerWidth);
  };

  const fetchPhaseFilterData = async () => {
    try {
      if (projectId) {
        const response = await documentApis.phaseList({ projectId });
        const phases = response?.data || response || [];
        const options = phases.map((item: any) => ({
          label: wbsName(item.phaseName),
          value: item.phaseId.toString(), // Ensure value is string
        }));
        setPhaseFilterData(options);
      }
    } catch (error) {
      console.error("Error loading phase data:", error);
      setPhaseFilterData([]);
    }
  };

  // Fetch site users by site ID
  const fetchSiteUsersBySiteId = async (siteId: number) => {
    try {
      const response = await buyerApis.fetchSiteUsers(siteId);
      const { data, status } = response || {};
      if (status && data) {
        const users = data.map((item: any) => ({
          label: item.userName,
          value: item.userId, // Use userId instead of appUserId
        }));
        setSiteUsers(users);
        return users;
      }
      return [];
    } catch (error) {
      console.error("Error fetching site users:", error);
      return [];
    }
  };

  // Fetch address by site ID
  const fetchAddressBySiteId = async (siteId: number) => {
    try {
      const response = await buyerApis.fetchAddressBySiteId(siteId);
      const { data, status } = response || {};
      if (status && data) {
        const addresses = data.map((item: any) => ({
          label: item.deliveryLocationName,
          value: item.id.toString(),
        }));
        setSiteAddresses(addresses);
        setSiteAddressesList(data);
        return data;
      }
      return null;
    } catch (error) {
      console.error("Error fetching address:", error);
      return null;
    }
  };

  // Fetch contractor list by site ID
  const fetchContractorList = useCallback(async (siteId: number | string) => {
    try {
      const { data, status } = await contractorsApis.fetchContractorBySiteId({
        id: siteId?.toString(),
      });
      if (status && data) {
        const options = data.map((item: any) => ({
          label: item?.companyName,
          value: item?.contractorID?.toString(),
        }));
        setContractorOptions(options);
      } else {
        setContractorOptions([]);
      }
    } catch (error) {
      console.error("Error fetching contractors:", error);
      setContractorOptions([]);
    }
  }, []);

  const fetchSiteSegmentLevel = useCallback(async (siteId: number) => {
    try {
      const response = await buyerApis.fetchSegmentLevelBySiteId(siteId);
      setSiteSegmentLevel(response?.data ?? null);
    } catch (error) {
      console.error("Error fetching site segment level:", error);
      setSiteSegmentLevel(null);
    }
  }, []);

  useEffect(() => {
    if (projectSiteId) {
      fetchContractorList(projectSiteId);
    }
  }, [projectSiteId, fetchContractorList]);

  // Re-fetch inventory whenever the contractor selection changes (added or cleared),
  // but only after the user has already applied filters at least once.
  useEffect(() => {
    if (hasFiltersApplied) {
      fetchInventoryData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedContractorId]);

  // Fetch sequence data
  const fetchSequenceData = async () => {
    try {
      const response = await buyerApis.fetchSequence();
      const { data } = response || {};
      if (data) {
        const today = new Date();
        const activeModules = data
          .filter(
            (item: any) =>
              new Date(item.endDate) > today && item.status === "Active"
          )
          .map((item: any) => item.moduleName);
        setSequenceData(activeModules);
        return activeModules;
      }
      return [];
    } catch (error) {
      console.error("Error fetching sequence data:", error);
      return [];
    }
  };

  // Open PR modal and fetch required data
  const openPrModal = async () => {
    setPrModal(true);
    try {
      // Fetch all required data when modal opens
      await Promise.all([
        fetchSiteUsersBySiteId(projectSiteId),
        fetchAddressBySiteId(projectSiteId),
        fetchSequenceData(),
      ]);
    } catch (error) {
      console.error("Error fetching PR modal data:", error);
    }
  };

  // Create purchase request
  const createPurchaseRequest = async (inventoryData: any) => {
    setIsPrLoading(true);
    try {
      // Get current date
      const currentDate = new Date().toISOString().split("T")[0];

      // Validate form data
      if (!selectedContractorId) {
        throw new Error("Please select a contractor before creating a PR");
      }

      if (!prFormData.requestedBy) {
        throw new Error("Please select a requested by user");
      }

      if (!prFormData.deliveryAddress) {
        throw new Error("Please select a delivery address");
      }

      if (!prFormData.needByDate) {
        throw new Error("Please select need by date");
      }

      // Only validate PR sequence if "Purchase Request" is not in sequence data
      if (
        !sequenceData.includes("Purchase Request") &&
        !prFormData.prSequence
      ) {
        throw new Error("Please enter PR sequence");
      }

      // Filter only materials that have been modified with meaningful values
      const modifiedMaterials = inventoryData.filter((material: any) => {
        // Check if any task in this material has been modified with meaningful value
        return (material.tasks || []).some((task: any) => {
          const hasChanges = inputValues[task.key] !== undefined;
          const hasValidValue =
            inputValues[task.key] !== "" &&
            inputValues[task.key] !== 0 &&
            inputValues[task.key] !== null &&
            inputValues[task.key] !== undefined;
          return hasChanges && hasValidValue;
        });
      });

      // Prepare PR header
      const prHeader: any = {
        indentDate: currentDate,
        needByDate: prFormData.needByDate,
        siteId: projectSiteId,
        levelType: "Site",
        segmentLevel: siteSegmentLevel,
        requestedBy: parseInt(prFormData.requestedBy), // Convert to number
        deliveryAddressId: parseInt(prFormData.deliveryAddress), // Convert to number
        contractorId: parseInt(selectedContractorId), // Selected contractor
        status: "DRAFT", // Static value
        prSource: "TASK", // Static value
      };

      // Only add prSequence if "Purchase Request" is not in sequence data
      if (!sequenceData.includes("Purchase Request")) {
        prHeader.prSequence = prFormData.prSequence;
      }

      // Prepare PR lines from only modified materials
      const prLines = modifiedMaterials.map((item: any) => {
        // Resolve the final quantity for each task once, so siteStructures and
        // taskBoqs stay in sync.
        const tasksWithQty: { task: any; quantity: number }[] = (
          item.tasks || []
        ).map((task: any) => {
          const rawInput = inputValues[task.key];
          const quantity =
            rawInput !== undefined
              ? rawInput === "" || rawInput === 0
                ? 0
                : Number(rawInput)
              : task.quantityToRequest === "" || task.quantityToRequest === 0
              ? 0
              : Number(task.quantityToRequest) || 0;
          return { task, quantity };
        });

        // Group task quantities by site-structure key
        // (siteStructureUnitId | floorNo | siteStructureSubUnitId).
        // locationId is carried through but does not participate in grouping.
        // Tasks with all-null structure fields are skipped — sites without a
        // structure are sent as an empty siteStructures array.
        const siteStructureMap = new Map<string, any>();
        tasksWithQty.forEach(({ task, quantity }) => {
          if (!quantity) return;
          const unitId = task.siteStructureUnitId ?? null;
          const unitName = task.siteStructureUnitName ?? null;
          const floorNo = task.floorNo ?? null;
          const subUnitId = task.siteStructureSubUnitId ?? null;
          const locationId = task.locationId ?? null;
          if (unitId === null && floorNo === null && subUnitId === null) {
            return;
          }
          const key = `${unitId}|${floorNo}|${subUnitId}`;
          const existing = siteStructureMap.get(key);
          if (existing) {
            existing.quantity += quantity;
          } else {
            siteStructureMap.set(key, {
              siteStructureUnitId: unitId,
              siteStructureUnitName: unitName,
              floorNo,
              siteStructureSubUnitId: subUnitId,
              locationId,
              segmentLevel: siteSegmentLevel,
              quantity,
            });
          }
        });

        const materialQuantity = tasksWithQty.reduce(
          (sum, t) => sum + (t.quantity || 0),
          0
        );

        return {
          materialId: item.materialId || 0,
          materialName: item.material,
          categoryId: item.categoryId || 0,
          categoryName: item.categoryName || "",
          uomId: item.uomId || 0,
          uomName: item.uom,
          quantity: materialQuantity,
          specification: item.specification || "",
          remarks: item.remarks || "",
          siteStructures: Array.from(siteStructureMap.values()),
          taskBoqs: tasksWithQty.map(({ task, quantity }) => ({
            taskBoqLineId: task.taskBoqLineId || 0,
            quantity,
            siteStructureUnitId: task.siteStructureUnitId ?? null,
            floorNo: task.floorNo ?? null,
            siteStructureSubUnitId: task.siteStructureSubUnitId ?? null,
          })),
        };
      });

      // Create form data for multipart/form-data
      const formData = new FormData();
      formData.append("prHeader", JSON.stringify(prHeader));
      formData.append("prLines", JSON.stringify(prLines));

      // Make API call
      const response = await buyerApis.createPurhcaseRequest(formData);

      if (response?.status) {
        return {
          success: true,
          data: response,
          message: "Purchase request created successfully",
        };
      } else {
        throw new Error(
          response?.message || "Failed to create purchase request"
        );
      }
    } catch (error: any) {
      console.error("Error creating purchase request:", error);
      return {
        success: false,
        error: error?.message || "Unknown error occurred",
      };
    } finally {
      setIsPrLoading(false);
    }
  };

  const fetchActivityFilterData = async () => {
    try {
      if (projectId) {
        const response = await documentApis.fetchActivityDropDown({
          projectId,
        });
        const activities = response?.data || response || [];
        const options = activities.map((item: any) => ({
          label: wbsName(item.activityName),
          value: item.activityId.toString(), // Ensure value is string
        }));
        setActivityFilterData(options);
      }
    } catch (error) {
      console.error("Error loading activity data:", error);
      setActivityFilterData([]);
    }
  };

  // Function to fetch and map inventory data from API
  const fetchInventoryData = useCallback(async () => {
    if (isLoading) return; // Prevent multiple simultaneous calls
    setIsLoading(true);
    try {
      // Using project ID from location state and filter data
      const params = {
        projectIds: projectId?.toString() || "",
        phaseIds: Array.isArray(filteredData.phaseIds)
          ? filteredData.phaseIds.join(",")
          : filteredData.phaseIds || "",
        activityIds: Array.isArray(filteredData.activityIds)
          ? filteredData.activityIds.join(",")
          : filteredData.activityIds || "",
        startDate:
          filteredData.startDate ||
          customDateRange?.[0]?.format("YYYY-MM-DD") ||
          "",
        endDate:
          filteredData.endDate ||
          customDateRange?.[1]?.format("YYYY-MM-DD") ||
          "",
        taskStatus: filteredData.taskStatus || [],
        showOnlyShortageMaterials: filteredData.showOnlyShortageMaterials || "",
        contractorIds: selectedContractorId || "",
      };

      // API call parameters prepared

      const response = await buyerApis.fetchGroupByMaterials(params);

      if (response && response.data) {
        // Map the API response to the existing MaterialRow structure
        const mappedData = response.data.map((item: any, index: number) => ({
          key: (index + 1).toString(),
          material: item.materialName || `Material ${index + 1}`,
          requiredQuantity: parseInt(item.totalAllocatedQty) || 0,
          stockAvailable: parseInt(item.availableQuantity) || 0,
          quantityToRequest: "", // Start with empty instead of 0
          inProgressQuantity: parseInt(item.underPriceEnquiryQuantity) || 0,
          underPriceEnquiryQuantity:
            parseInt(item.underPriceEnquiryQuantity) || 0,
          releasedOrderQuantity: parseInt(item.releasedOrderQuantity) || 0,
          uom: item.uomName || "Units",
          materialId: item.materialId,
          categoryId: item.categoryId,
          categoryName: item.categoryName,
          uomId: item.uomId,
          tasks:
            item.tasks?.map((task: any, taskIndex: number) => ({
              key: `${index + 1}-${taskIndex + 1}`,
              task: task.taskName || `Task ${taskIndex + 1}`,
              requiredQuantity: parseInt(task.allocatedQuantity) || 0,
              quantityToRequest: "", // Start with empty instead of 0
              inProgressQuantity: parseInt(task.underPriceEnquiryQuantity) || 0,
              underPriceEnquiryQuantity:
                parseInt(task.underPriceEnquiryQuantity) || 0,
              releasedOrderQuantity: parseInt(task.releasedOrderQuantity) || 0,
              uom: item.uomName || "Units",
              taskBoqLineId: task.id,
              siteStructureUnitId: task.siteStructureUnitId ?? null,
              siteStructureUnitName: task.siteStructureUnitName ?? null,
              floorNo: task.floorNo ?? null,
              siteStructureSubUnitId: task.siteStructureSubUnitId ?? null,
              locationId: task.locationId ?? null,
            })) || [],
        }));

        // Update the state with the mapped data
        setRows(mappedData);
        setDisplayRows(mappedData);
        setHasFiltersApplied(true); // Mark that filters have been applied
      } else {
        // API returned empty data
        setRows([]);
        setDisplayRows([]);
        setHasFiltersApplied(true); // Mark that filters have been applied
      }
    } catch (error) {
      console.error("Error fetching inventory data:", error);
      // Set empty arrays on error
      setRows([]);
      setDisplayRows([]);
      setHasFiltersApplied(true); // Mark that filters have been applied
    } finally {
      setIsLoading(false);
    }
  }, [projectId, filteredData, isLoading, selectedContractorId]);

  const refreshListView = () => {
    try {
      // Only refresh if filter data exists (date range is required)
      if (filteredData.startDate && filteredData.endDate) {
        fetchInventoryData();
      } else {
        // Show message to user that filters need to be applied first
        Swal.fire({
          title: "No Filters Applied",
          text: "Please apply filters first before refreshing data.",
          icon: "info",
          confirmButtonText: "OK",
          confirmButtonColor: "#1890ff",
        });
      }
    } catch (error) {}
  };

  const columns: ColumnsType<any> = useMemo(
    () => [
      {
        title: "Material",
        dataIndex: "material",
        key: "material",
        width: screenSize < 768 ? 100 : 160,
        fixed: "left",
        align: "left",
        ellipsis: true,
        render: (text: any, record: any) => {
          if (record.children !== undefined) {
            // This is a parent row (material)
            return (
              <span style={{ color: "#2557d6", fontWeight: "600" }}>
                {text}
              </span>
            );
          } else {
            // This is a child row (task)
            return (
              <span style={{ color: "#666", paddingLeft: "20px" }}>
                <TaskIcon className="me-1" width={14} height={14} /> {text}
              </span>
            );
          }
        },
      },
      {
        title: "Required Quantity",
        dataIndex: "requiredQuantity",
        key: "requiredQuantity",
        width: screenSize < 768 ? 120 : 180,
        align: "left",
        ellipsis: true,
        render: (value: any, record: any) => {
          if (record.children !== undefined) {
            // This is a parent row (material)
            return (
              <span>
                {value} {record.uom}
              </span>
            );
          } else {
            // This is a child row (task)
            return (
              <span>
                {value} {record.uom}
              </span>
            );
          }
        },
      },
      {
        title: "Stock Available",
        dataIndex: "stockAvailable",
        key: "stockAvailable",
        width: screenSize < 768 ? 120 : 180,
        align: "left",
        ellipsis: true,
        render: (value: any, record: any) => {
          if (record.children !== undefined) {
            // This is a parent row (material)
            return (
              <span>
                {value} {record.uom}
              </span>
            );
          } else {
            // This is a child row (task)
            return (
              <span>{value === "-" ? "-" : `${value} ${record.uom}`}</span>
            );
          }
        },
      },
      {
        title: "Shortage",
        dataIndex: "shortage",
        key: "shortage",
        width: screenSize < 768 ? 120 : 180,
        align: "left",
        ellipsis: true,
        render: (value: any, record: any) => {
          if (record.children !== undefined) {
            // This is a parent row (material) - show shortage
            const shortage = Math.max(
              0,
              record.requiredQuantity - record.stockAvailable
            );
            return (
              <span
                style={{
                  color: shortage > 0 ? "#dc3545" : "#28a745",
                  fontWeight: "500",
                }}
              >
                {shortage} {record.uom}
              </span>
            );
          } else {
            // This is a child row (task) - show "-"
            return <span style={{ color: "#999" }}>-</span>;
          }
        },
      },
      {
        title: "Under Price Enquiry",
        dataIndex: "underPriceEnquiryQuantity",
        key: "underPriceEnquiryQuantity",
        width: screenSize < 768 ? 140 : 200,
        align: "left",
        ellipsis: true,
        render: (value: any, record: any) => {
          if (record.children !== undefined) {
            return (
              <span>
                {record.underPriceEnquiryQuantity || 0} {record.uom}
              </span>
            );
          } else {
            return (
              <span>
                {record.underPriceEnquiryQuantity || 0} {record.uom}
              </span>
            );
          }
        },
      },
      {
        title: "Order Placed",
        dataIndex: "releasedOrderQuantity",
        key: "releasedOrderQuantity",
        width: screenSize < 768 ? 140 : 200,
        align: "left",
        ellipsis: true,
        render: (value: any, record: any) => {
          if (record.children !== undefined) {
            return (
              <span>
                {record.releasedOrderQuantity || 0} {record.uom}
              </span>
            );
          } else {
            return (
              <span>
                {record.releasedOrderQuantity || 0} {record.uom}
              </span>
            );
          }
        },
      },
      {
        title: "Quantity to Request",
        dataIndex: "quantityToRequest",
        key: "quantityToRequest",
        width: screenSize < 768 ? 100 : 160,
        fixed: "right",
        align: "left",
        ellipsis: true,
        render: (value: any, record: any) => {
          if (record.children !== undefined) {
            return (
              <span>
                {value || 0} {record.uom}
              </span>
            );
          } else {
            const currentQty =
              inputValues[record.key] !== undefined
                ? inputValues[record.key]
                : record.quantityToRequest || "";
            const requiredQty = record.requiredQuantity;
            const stockAvailable =
              record.stockAvailable === "-"
                ? (record.parentStockAvailable ?? 0)
                : (record.stockAvailable ?? 0);
            const quantityInfo = getQuantityInfo(
              currentQty,
              requiredQty,
              stockAvailable
            );
            const showInfo = quantityInfo != null;

            return (
              <div>
                <InputNumber
                  key={`input-${record.key}`}
                  ref={(el) => {
                    inputRefs.current[record.key] = el;
                  }}
                  min={0}
                  max={999999}
                  precision={2}
                  step={0.01}
                  value={
                    inputValues[record.key] !== undefined
                      ? inputValues[record.key]
                      : record.quantityToRequest || ""
                  }
                  onFocus={() => handleInputFocus(record.key)}
                  onBlur={() => handleInputBlur(record.key)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      (e.target as HTMLInputElement).blur();
                    }
                    // Allow: backspace, delete, tab, escape, enter, decimal point, navigation keys
                    if (
                      [
                        "Backspace",
                        "Delete",
                        "Tab",
                        "Escape",
                        "Enter",
                        ".",
                        "Home",
                        "End",
                        "ArrowLeft",
                        "ArrowRight",
                        "ArrowUp",
                        "ArrowDown",
                      ].includes(e.key) ||
                      // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
                      (e.key === "a" && e.ctrlKey) ||
                      (e.key === "c" && e.ctrlKey) ||
                      (e.key === "v" && e.ctrlKey) ||
                      (e.key === "x" && e.ctrlKey)
                    ) {
                      return;
                    }
                    // Ensure that it is a number and stop the keypress
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onChange={(val) => {
                    if (val === null || val === undefined || val === "") {
                      handleInputChange(record.key, "");
                      return;
                    }
                    // Ensure only positive numbers
                    if (typeof val === "number" && val >= 0) {
                      handleInputChange(record.key, val);
                    }
                  }}
                  onCompositionStart={() => setIsTyping(true)}
                  onCompositionEnd={() => setIsTyping(false)}
                  style={{
                    width: "100%",
                  }}
                  placeholder="Enter qty"
                  size="small"
                  autoFocus={false}
                  controls={false}
                />
                {showInfo && quantityInfo && (
                  <div
                    style={{
                      marginTop: "4px",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      fontSize: "12px",
                    }}
                  >
                    <span style={{ fontSize: "14px" }}>
                      {quantityInfo?.icon}
                    </span>
                    <span
                      style={{ color: quantityInfo?.color, fontWeight: "500" }}
                    >
                      {quantityInfo?.message}
                    </span>
                  </div>
                )}
              </div>
            );
          }
        },
      },
    ],
    [
      inputValues,
      handleInputChange,
      handleInputFocus,
      handleInputBlur,
      screenSize,
    ]
  );

  useEffect(() => {
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
    };
  }, []);

  useEffect(() => {
    const initialInputValues: Record<string, number | string> = {};
    displayRows.forEach((material) => {
      material.tasks?.forEach((task) => {
        initialInputValues[task.key] = task.quantityToRequest || "";
      });
    });
    setInputValues(initialInputValues);
  }, []);

  useEffect(() => {
    setDisplayRows(rows);
  }, []);

  useEffect(() => {
    if (projectId) {
      // Set task status list with fixed values
      const fixedStatusList = [
        { label: "Draft", value: "Draft" },
        { label: "Active", value: "Active" },
        { label: "Open", value: "Open" },
        { label: "InProgress", value: "InProgress" },
        { label: "OnHold", value: "OnHold" },
        { label: "UnderQC", value: "UnderQC" },
      ];
      setTaskStatusFilterData(fixedStatusList);
    }
  }, [projectId]);

  useEffect(() => {
    if (filtersModal) {
      // Clear form errors when modal opens
      methods.clearErrors();
      setIsFormSubmitted(false);

      // Always fetch fresh filter data when modal opens to ensure data is current
      // Also force fetch if previous data was cleared (arrays are empty)
      if (phaseFilterData.length === 0 || activityFilterData.length === 0) {
        setHasFilterDataBeenFetched(false);
      }

      fetchPhaseFilterData();
      fetchActivityFilterData();

      // Set flag to prevent multiple API calls during the same modal session
      if (!hasFilterDataBeenFetched) {
        setHasFilterDataBeenFetched(true);
      }

      // Sync the form with current filtered data when modal opens
      // If filteredData is empty, set default values

      // Handle phase IDs
      if (filteredData.phaseIds && filteredData.phaseIds.length > 0) {
        let phaseIds;
        if (typeof filteredData.phaseIds === "string") {
          phaseIds = filteredData.phaseIds.split(",").filter(Boolean);
        } else if (Array.isArray(filteredData.phaseIds)) {
          phaseIds = filteredData.phaseIds;
        } else {
          phaseIds = [];
        }
        methods.setValue("phaseIds", phaseIds);
      } else {
        // Always set empty if no data
        methods.setValue("phaseIds", []);
      }

      // Handle activity IDs
      if (filteredData.activityIds && filteredData.activityIds.length > 0) {
        let activityIds;
        if (typeof filteredData.activityIds === "string") {
          activityIds = filteredData.activityIds.split(",").filter(Boolean);
        } else if (Array.isArray(filteredData.activityIds)) {
          activityIds = filteredData.activityIds;
        } else {
          activityIds = [];
        }
        methods.setValue("activityIds", activityIds);
      } else {
        // Always set empty if no data
        methods.setValue("activityIds", []);
      }

      // Handle task status
      if (filteredData.taskStatus && filteredData.taskStatus.length > 0) {
        methods.setValue("taskStatus", filteredData.taskStatus);
      } else {
        // Always set empty if no data
        methods.setValue("taskStatus", []);
      }

      // Handle show only shortage materials
      if (filteredData.showOnlyShortageMaterials) {
        methods.setValue(
          "showOnlyShortageMaterials",
          filteredData.showOnlyShortageMaterials
        );
      } else {
        // Always set empty if no data
        methods.setValue("showOnlyShortageMaterials", "");
      }

      // Sync date range
      if (filteredData.startDate && filteredData.endDate) {
        setCustomDateRange([
          dayjs(filteredData.startDate),
          dayjs(filteredData.endDate),
        ]);
      } else {
        // Always set null if no data
        setCustomDateRange(null);
      }

      // Form will re-render with current values automatically
    }
  }, [
    filtersModal, // Only depend on filtersModal to prevent continuous API calls
  ]);

  const tableData = useMemo(() => {
    // Filter rows based on search query - only material names
    const filteredRows = searchQuery
      ? displayRows.filter((material) =>
          material.material.toLowerCase().includes(searchQuery.toLowerCase())
        )
      : displayRows;

    return filteredRows.map((material) => ({
      key: material.key,
      material: material.material,
      requiredQuantity: material.requiredQuantity,
      stockAvailable: material.stockAvailable,
      quantityToRequest: material.quantityToRequest,
      inProgressQuantity: material.inProgressQuantity,
      uom: material.uom,
      underPriceEnquiryQuantity: material.underPriceEnquiryQuantity,
      releasedOrderQuantity: material.releasedOrderQuantity,
      children: material.tasks?.map((task) => ({
        key: task.key,
        material: task.task,
        requiredQuantity: task.requiredQuantity,
        stockAvailable: "-",
        parentStockAvailable: material.stockAvailable,
        quantityToRequest:
          isTyping && inputValues[task.key] !== undefined
            ? inputValues[task.key]
            : task.quantityToRequest || "",
        inProgressQuantity: task.inProgressQuantity,
        uom: task.uom,
        underPriceEnquiryQuantity: task.underPriceEnquiryQuantity,
        releasedOrderQuantity: task.releasedOrderQuantity,
      })),
    }));
  }, [displayRows, isTyping, inputValues, searchQuery]);

  const memoizedColumns = useMemo(() => columns, [columns]);

  useEffect(() => {
    dispatch(
      updateMenuData(
        TopMenu?.projectNav?.map((item: any) => ({
          ...item,
          linkState: location.state,
        }))
      )
    );
  }, [location]);

  const forecastToolbar = (
    <>
      <div style={{ width: "260px" }}>
        <Select
          placeholder="Select Contractor"
          value={selectedContractorId}
          onChange={(value) => setSelectedContractorId(value)}
          options={contractorOptions}
          style={{ width: "100%", height: "36px" }}
          allowClear
          showSearch
          optionFilterProp="label"
        />
      </div>
      <div style={{ flex: 1 }}>
        <Input
          placeholder="Search materials..."
          prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{
            borderRadius: "6px",
            height: "36px",
            width: "100%",
          }}
          allowClear
        />
      </div>
      <AntButton
        type="primary"
        icon={<EyeOutlined />}
        onClick={async () => {
          if (projectSiteId) {
            await fetchSiteSegmentLevel(projectSiteId);
          }
          setPreviewModal(true);
        }}
        disabled={!hasValidChanges() || !selectedContractorId}
      >
        Preview
      </AntButton>
      <UncontrolledDropdown>
        <DropdownToggle
          tag="a"
          className="dropdown-toggle btn btn-icon btn-trigger"
          onClick={(ev) => {
            refreshListView();
          }}
          title="Refresh with current filters"
        >
          <Icon name="redo"></Icon>
        </DropdownToggle>
      </UncontrolledDropdown>
      <a
        href="#filter"
        onClick={(ev) => {
          ev.preventDefault();
          setFiltersModal(true);
        }}
        className={`btn-icon me-2`}
      >
        <Badge color="geekblue" size="small" count={calculateFilterCount()}>
          <Icon style={{ fontSize: "20px" }} name="filter"></Icon>
        </Badge>
      </a>
    </>
  );

  return (
    <React.Fragment>
      <ProjectPageShell
        headTitle="Inventory Analysis"
        breadcrumb={[
          { label: projectName },
          { label: "Material Forecast" },
        ]}
        title="Material Forecast"
        eyebrow="Inventory"
        tabs={
          <Tabs
            className="pms-tabs"
            activeKey={activeTab}
            onChange={(key) => setActiveTab(key)}
            items={[
              { key: "forecast", label: "Material Forecast" },
              { key: "indent", label: "Track Indent" },
            ]}
          />
        }
        toolbar={activeTab === "forecast" ? forecastToolbar : undefined}
      >
        {activeTab === "indent" ? (
          // TrackIndentList manages its own inner scroll (height:100% flex
          // column), so it keeps a bounded viewport-derived height — the one
          // intentional exception to the shell's natural flow.
          <div
            style={{
              height: "calc(100vh - 300px)",
              minHeight: 420,
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <TrackIndentList
              projectId={projectId}
              projectName={projectName}
              siteId={projectSiteId}
            />
          </div>
        ) : (
          <div>
            <style>
              {`
                .customTable .ant-table-thead > tr > th:hover {
                  background-color: #fafafa !important;
                }
                .customTable .ant-table-thead > tr > th.ant-table-column-sort:hover {
                  background-color: #fafafa !important;
                }
                .customTable .ant-table-tbody > tr > td:last-child {
                  border-right: none !important;
                }
                .customTable .ant-table-tbody > tr > td:last-child .ant-input-number {
                  border: none !important;
                  box-shadow: none !important;
                }
                .customTable .ant-table-tbody > tr > td:last-child .ant-input-number:focus {
                  border: 1px solid #1890ff !important;
                  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
                }
              `}
            </style>
            {tableData.length === 0 && !isLoading ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "60px 20px",
                          textAlign: "center",
                          backgroundColor: "#ffffff",
                          borderRadius: "8px",
                          border: "1px solid #d9d9d9",
                          margin: "20px 0",
                          minHeight: "300px",
                        }}
                      >
                        <div
                          style={{
                            width: "64px",
                            height: "64px",
                            backgroundColor: "#f6f8fa",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginBottom: "20px",
                          }}
                        >
                          <Icon
                            name="package"
                            style={{
                              fontSize: "28px",
                              color: "#2557d6",
                            }}
                          />
                        </div>
                        <h4
                          style={{
                            color: "#262626",
                            marginBottom: "8px",
                            fontSize: "18px",
                            fontWeight: "600",
                          }}
                        >
                          {hasFiltersApplied
                            ? "No data found"
                            : "No inventory data available"}
                        </h4>
                        <p
                          style={{
                            color: "#8c8c8c",
                            marginBottom: "16px",
                            fontSize: "14px",
                            lineHeight: "1.5",
                            maxWidth: "320px",
                            fontFamily: "Inter, Roboto, sans-serif",
                          }}
                        >
                          {hasFiltersApplied ? (
                            <>
                              No data matches your filters. Try{" "}
                              <span
                                style={{
                                  color: "#2557d6",
                                  fontWeight: "500",
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                  transition: "color 0.2s ease",
                                }}
                                onClick={() => setFiltersModal(true)}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.color = "#1a4d8c";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.color = "#2557d6";
                                }}
                              >
                                adjusting filters
                              </span>{" "}
                              to see results.
                            </>
                          ) : (
                            <>
                              <span
                                style={{
                                  color: "#2557d6",
                                  fontWeight: "500",
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                  transition: "color 0.2s ease",
                                }}
                                onClick={() => setFiltersModal(true)}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.color = "#1a4d8c";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.color = "#2557d6";
                                }}
                              >
                                Select
                              </span>{" "}
                              your planned task dates for inventory analysis
                            </>
                          )}
                        </p>
                      </div>
                    ) : (
                      <SkeletonTable
                        loading={isLoading}
                        columns={memoizedColumns as SkeletonTableColumnsType[]}
                      >
                        <Table
                          className="customTable pms-hub-table"
                          columns={memoizedColumns}
                          dataSource={tableData}
                          pagination={false}
                          size="small"
                          scroll={{ x: 1320 }}
                          expandable={{
                            defaultExpandAllRows: true,
                          }}
                          rowKey="key"
                        />
                      </SkeletonTable>
                    )}
          </div>
        )}
      </ProjectPageShell>

      <Drawer
        maskClosable={false}
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <span>Inventory Preview</span>
            <div>
              <Button
                color="primary"
                size="sm"
                onClick={() => {
                  if (!selectedContractorId) {
                    Swal.fire({
                      title: "Contractor Required",
                      text: "Please select a contractor before creating a PR.",
                      icon: "warning",
                      confirmButtonText: "OK",
                      confirmButtonColor: "#1890ff",
                    });
                    return;
                  }
                  openPrModal();
                }}
                disabled={!hasValidChanges() || !selectedContractorId}
              >
                <Icon name="send" style={{ marginRight: "4px" }} />
                Generate PR
              </Button>
            </div>
          </div>
        }
        placement="right"
        width={1200}
        onClose={() => setPreviewModal(false)}
        open={previewModal}
        styles={{ body: { paddingBottom: 80 } }}
      >
        <Tabs
          defaultActiveKey="task-wise"
          items={[
            {
              key: "task-wise",
              label: "Task-wise",
              children: (
                <div>
                  <h5>Task-wise Materials (Changed Only)</h5>
                  <p>
                    {!hasValidChanges()
                      ? "No changes have been made to any materials. Please modify quantities in the main table first."
                      : "This tab shows only materials and tasks that have been modified."}
                  </p>
                  <div style={{ marginTop: "16px" }}>
                    <Table
                      className="customTable"
                      columns={[
                        {
                          title: "Task",
                          dataIndex: "task",
                          key: "task",
                          render: (text: any) => (
                            <span style={{ color: "#666" }}>
                              <TaskIcon
                                className="me-1"
                                width={14}
                                height={14}
                              />{" "}
                              {text}
                            </span>
                          ),
                        },
                        {
                          title: "Material",
                          dataIndex: "material",
                          key: "material",
                        },
                        {
                          title: "Required Qty",
                          dataIndex: "requiredQty",
                          key: "requiredQty",
                          render: (value: any, record: any) =>
                            `${value} ${record.uom}`,
                        },
                        {
                          title: "Qty to Request",
                          dataIndex: "qtyToRequest",
                          key: "qtyToRequest",
                          render: (value: any, record: any) =>
                            `${value} ${record.uom}`,
                        },
                        {
                          title: "Under Price Enquiry",
                          dataIndex: "priceEnquiry",
                          key: "priceEnquiry",
                          render: (value: any, record: any) =>
                            `${value || 0} ${record.uom}`,
                        },
                        {
                          title: "Order Placed",
                          dataIndex: "releasedOrder",
                          key: "releasedOrder",
                          render: (value: any, record: any) =>
                            `${value || 0} ${record.uom}`,
                        },
                      ]}
                      dataSource={(() => {
                        // Filter to show only changed tasks
                        const changedTasks = displayRows.flatMap((material) =>
                          (material.tasks || [])
                            .filter((task) => {
                              // Show task if it has been modified with meaningful value
                              const hasChanges =
                                inputValues[task.key] !== undefined;
                              const hasValidValue =
                                inputValues[task.key] !== "" &&
                                inputValues[task.key] !== 0 &&
                                inputValues[task.key] !== null &&
                                inputValues[task.key] !== undefined;
                              return hasChanges && hasValidValue;
                            })
                            .map((task) => ({
                              key: task.key,
                              task: task.task,
                              material: material.material,
                              requiredQty: task.requiredQuantity,
                              qtyToRequest:
                                inputValues[task.key] !== undefined
                                  ? inputValues[task.key]
                                  : task.quantityToRequest,
                              priceEnquiry: task.underPriceEnquiryQuantity || 0,
                              releasedOrder: task.releasedOrderQuantity || 0,
                              uom: task.uom,
                            }))
                        );

                        // If no meaningful changes, show a message
                        if (changedTasks.length === 0) {
                          return [
                            {
                              key: "no-changes",
                              task: "No Changes",
                              material: "No materials have been modified",
                              requiredQty: 0,
                              qtyToRequest: 0,
                              priceEnquiry: 0,
                              releasedOrder: 0,
                              uom: "",
                            },
                          ];
                        }

                        return changedTasks;
                      })()}
                      pagination={false}
                      size="small"
                      bordered
                    />
                  </div>
                </div>
              ),
            },
            {
              key: "material-wise",
              label: "Material-wise",
              children: (
                <div>
                  <h5>Material-wise Summary (Changed Only)</h5>
                  <p>
                    {!hasValidChanges()
                      ? "No changes have been made to any materials. Please modify quantities in the main table first."
                      : "This tab shows only materials that have been modified."}
                  </p>
                  <div style={{ marginTop: "16px" }}>
                    <Table
                      className="customTable"
                      columns={[
                        {
                          title: "Material",
                          dataIndex: "material",
                          key: "material",
                        },
                        {
                          title: "Required Qty",
                          dataIndex: "requiredQty",
                          key: "requiredQty",
                          render: (value: any, record: any) =>
                            `${value} ${record.uom}`,
                        },
                        {
                          title: "Stock Available",
                          dataIndex: "stockAvailable",
                          key: "stockAvailable",
                          render: (value: any, record: any) =>
                            `${value} ${record.uom}`,
                        },
                        {
                          title: "Qty to Request",
                          dataIndex: "qtyToRequest",
                          key: "qtyToRequest",
                          render: (value: any, record: any) =>
                            `${value} ${record.uom}`,
                        },
                        {
                          title: "Under Price Enquiry",
                          dataIndex: "underPriceEnquiryQuantity",
                          key: "underPriceEnquiryQuantity",
                          render: (value: any, record: any) =>
                            `${record.underPriceEnquiryQuantity || 0} ${
                              record.uom
                            }`,
                        },
                        {
                          title: "Order Placed",
                          dataIndex: "releasedOrderQuantity",
                          key: "releasedOrderQuantity",
                          render: (value: any, record: any) =>
                            `${record.releasedOrderQuantity || 0} ${
                              record.uom
                            }`,
                        },
                      ]}
                      dataSource={(() => {
                        // Filter to show only materials with changed tasks
                        const changedMaterials = displayRows
                          .filter((material) => {
                            // Check if any task in this material has been modified with meaningful value
                            return (material.tasks || []).some((task) => {
                              const hasChanges =
                                inputValues[task.key] !== undefined;
                              const hasValidValue =
                                inputValues[task.key] !== "" &&
                                inputValues[task.key] !== 0 &&
                                inputValues[task.key] !== null &&
                                inputValues[task.key] !== undefined;
                              return hasChanges && hasValidValue;
                            });
                          })
                          .map((material) => {
                            // Calculate total quantity to request from tasks including exceeded values
                            const totalQtyToRequest = (
                              material.tasks || []
                            ).reduce((sum, task) => {
                              const taskQty =
                                inputValues[task.key] !== undefined
                                  ? inputValues[task.key]
                                  : task.quantityToRequest;
                              return sum + (Number(taskQty) || 0);
                            }, 0);

                            // Calculate original total quantity
                            const originalTotalQty = (
                              material.tasks || []
                            ).reduce(
                              (sum, task) =>
                                sum + (Number(task.quantityToRequest) || 0),
                              0
                            );

                            return {
                              key: material.key,
                              material: material.material,
                              requiredQty: material.requiredQuantity,
                              stockAvailable: material.stockAvailable,
                              qtyToRequest: totalQtyToRequest,
                              inProgressQty: material.inProgressQuantity,
                              uom: material.uom,
                              underPriceEnquiryQuantity:
                                material.underPriceEnquiryQuantity || 0,
                              releasedOrderQuantity:
                                material.releasedOrderQuantity || 0,
                            };
                          });

                        // If no meaningful changes, show a message
                        if (changedMaterials.length === 0) {
                          return [
                            {
                              key: "no-changes",
                              material: "No Changes",
                              requiredQty: 0,
                              stockAvailable: 0,
                              qtyToRequest: 0,
                              inProgressQty: 0,
                              uom: "",
                              underPriceEnquiryQuantity: 0,
                              releasedOrderQuantity: 0,
                            },
                          ];
                        }

                        return changedMaterials;
                      })()}
                      pagination={false}
                      size="small"
                      bordered
                    />
                  </div>
                </div>
              ),
            },
          ]}
        />
      </Drawer>

      <Drawer
        maskClosable={false}
        title={
          <div className="d-flex justify-content-between align-items-center">
            <strong>Filters</strong>
            <>
              <div style={{ textAlign: "right" }}>
                <Button
                  onClick={() => {
                    // Clear the form completely
                    methods.reset();

                    // Clear all filter states
                    setFilteredData({});
                    setCustomDateRange(null);
                    setSelectedDateRange(null);
                    setHasFiltersApplied(false);

                    // Clear all form fields to empty values and prevent default values from being set
                    methods.setValue("phaseIds", []);
                    methods.setValue("activityIds", []);
                    methods.setValue("taskStatus", []);
                    methods.setValue("showOnlyShortageMaterials", "");

                    // Clear form errors and reset submission state
                    methods.clearErrors();
                    setIsFormSubmitted(false);

                    // Set flag to prevent automatic default value setting
                    setHasResetBeenClicked(true);

                    // Keep the modal open - don't close it
                    // setFiltersModal(false); // Removed this line
                  }}
                  color=""
                  className="m-3 mt-0 mb-0 ps-4 pe-4"
                  size="sm"
                >
                  <span style={{ color: "#0772f8" }}>Reset</span>
                </Button>
              </div>
            </>
          </div>
        }
        placement="right"
        width={600}
        onClose={() => {
          setFiltersModal(false);
          // Reset the flag when modal is closed
          setHasResetBeenClicked(false);
          // Reset the filter data fetched flag to allow fresh fetch next time
          setHasFilterDataBeenFetched(false);
          // Clear form errors and reset submission state
          methods.clearErrors();
          setIsFormSubmitted(false);
        }}
        open={filtersModal}
        styles={{ body: { paddingBottom: 80 } }}
      >
        <div className="d-flex align-items-center flex-wrap w-100">
          <FormProvider {...methods}>
            <form
              onSubmit={async (e) => {
                e.preventDefault();

                // Set form as submitted to show validation errors
                setIsFormSubmitted(true);

                // Check if date range is selected
                if (
                  !customDateRange ||
                  !customDateRange[0] ||
                  !customDateRange[1]
                ) {
                  // Set error for date range field
                  methods.setError("dateRange", {
                    type: "required",
                    message: "This field is required",
                  });
                  return;
                }

                // If validation passes, proceed with form submission
                const data = methods.getValues();

                // Get the current form values directly from the form state to ensure we have the latest
                // Use watched values as fallback if getValues returns empty
                const currentPhaseIds =
                  methods.getValues("phaseIds") || watchedPhaseIds;
                const currentActivityIds =
                  methods.getValues("activityIds") || watchedActivityIds;

                // Ensure phaseIds and activityIds are arrays and handle edge cases
                let phaseIds: string[] = [];
                let activityIds: string[] = [];

                // Handle phaseIds - ensure it's always an array
                if (currentPhaseIds && currentPhaseIds.length > 0) {
                  if (Array.isArray(currentPhaseIds)) {
                    phaseIds = currentPhaseIds.filter(Boolean);
                  } else {
                    // Handle single value case
                    const phaseValue = String(currentPhaseIds);
                    phaseIds = phaseValue ? [phaseValue] : [];
                  }
                }

                // Handle activityIds - ensure it's always an array
                if (currentActivityIds && currentActivityIds.length > 0) {
                  if (Array.isArray(currentActivityIds)) {
                    activityIds = currentActivityIds.filter(Boolean);
                  } else {
                    // Handle single value case
                    const activityValue = String(currentActivityIds);
                    activityIds = activityValue ? [activityValue] : [];
                  }
                }

                // Form validation and processing

                // Get taskStatus and showOnlyShortageMaterials from form values
                const currentTaskStatus = methods.getValues("taskStatus");
                const currentShowOnlyShortageMaterials = methods.getValues(
                  "showOnlyShortageMaterials"
                );

                // Prepare filter data for API - store as arrays, not joined strings
                const apiFilterData = {
                  phaseIds: phaseIds,
                  activityIds: activityIds,
                  startDate: customDateRange?.[0]?.format("YYYY-MM-DD") || null,
                  endDate: customDateRange?.[1]?.format("YYYY-MM-DD") || null,
                  taskStatus: currentTaskStatus || null,
                  showOnlyShortageMaterials:
                    currentShowOnlyShortageMaterials || null,
                };

                // Update form values to ensure consistency BEFORE setting filteredData
                methods.setValue("phaseIds", phaseIds);
                methods.setValue("activityIds", activityIds);
                methods.setValue("taskStatus", currentTaskStatus || []);
                methods.setValue(
                  "showOnlyShortageMaterials",
                  currentShowOnlyShortageMaterials || ""
                );

                // Set filtered data with arrays (not joined strings)
                setFilteredData(apiFilterData);

                // Also update the form to ensure consistency
                methods.setValue("phaseIds", phaseIds);
                methods.setValue("activityIds", activityIds);
                methods.setValue("taskStatus", currentTaskStatus || []);
                methods.setValue(
                  "showOnlyShortageMaterials",
                  currentShowOnlyShortageMaterials || ""
                );

                setFiltersModal(false);
                // Reset the flag when form is submitted
                setHasResetBeenClicked(false);

                const directParams = {
                  projectIds: projectId?.toString() || "",
                  phaseIds: phaseIds.join(","),
                  activityIds: activityIds.join(","),
                  startDate: customDateRange?.[0]?.format("YYYY-MM-DD") || null,
                  endDate: customDateRange?.[1]?.format("YYYY-MM-DD") || null,
                  taskStatus: currentTaskStatus || [],
                  showOnlyShortageMaterials:
                    currentShowOnlyShortageMaterials || "",
                  contractorIds: selectedContractorId || "",
                };

                // Making direct API call with processed parameters

                // Make the API call directly instead of going through fetchInventoryData
                try {
                  setIsLoading(true);
                  const response = await buyerApis.fetchGroupByMaterials(
                    directParams
                  );

                  if (response && response.data) {
                    // Map the API response to the existing MaterialRow structure
                    const mappedData = response.data.map(
                      (item: any, index: number) => ({
                        key: (index + 1).toString(),
                        material: item.materialName || `Material ${index + 1}`,
                        requiredQuantity: parseInt(item.totalAllocatedQty) || 0,
                        stockAvailable: parseInt(item.availableQuantity) || 0,
                        quantityToRequest: "",
                        inProgressQuantity:
                          parseInt(item.underPriceEnquiryQuantity) || 0,
                        underPriceEnquiryQuantity:
                          parseInt(item.underPriceEnquiryQuantity) || 0,
                        releasedOrderQuantity:
                          parseInt(item.releasedOrderQuantity) || 0,
                        uom: item.uomName || "Units",
                        materialId: item.materialId,
                        categoryId: item.categoryId,
                        categoryName: item.categoryName,
                        uomId: item.uomId,
                        tasks:
                          item.tasks?.map((task: any, taskIndex: number) => ({
                            key: `${index + 1}-${taskIndex + 1}`,
                            task: task.taskName || `Task ${taskIndex + 1}`,
                            requiredQuantity:
                              parseInt(task.allocatedQuantity) || 0,
                            quantityToRequest: "",
                            inProgressQuantity:
                              parseInt(task.underPriceEnquiryQuantity) || 0,
                            underPriceEnquiryQuantity:
                              parseInt(task.underPriceEnquiryQuantity) || 0,
                            releasedOrderQuantity:
                              parseInt(task.releasedOrderQuantity) || 0,
                            uom: item.uomName || "Units",
                            taskBoqLineId: task.id,
                            siteStructureUnitId:
                              task.siteStructureUnitId ?? null,
                            siteStructureUnitName:
                              task.siteStructureUnitName ?? null,
                            floorNo: task.floorNo ?? null,
                            siteStructureSubUnitId:
                              task.siteStructureSubUnitId ?? null,
                            locationId: task.locationId ?? null,
                          })) || [],
                      })
                    );

                    setRows(mappedData);
                    setDisplayRows(mappedData);
                    setHasFiltersApplied(true); // Mark that filters have been applied
                  } else {
                    // API returned empty data
                    setRows([]);
                    setDisplayRows([]);
                    setHasFiltersApplied(true); // Mark that filters have been applied
                  }
                } catch (error) {
                  console.error("Error fetching inventory data:", error);
                  setRows([]);
                  setDisplayRows([]);
                  setHasFiltersApplied(true); // Mark that filters have been applied
                } finally {
                  setIsLoading(false);
                }
              }}
              className="w-100"
            >
              <div key={"filters1"} className="mb-2 mt-0">
                <label className="form-label">
                  Task Planned Start (From–To){" "}
                  <span className="text-danger">*</span>
                </label>
                <DatePicker.RangePicker
                  value={
                    customDateRange
                      ? [dayjs(customDateRange[0]), dayjs(customDateRange[1])]
                      : null
                  }
                  onChange={(dates) => {
                    if (dates && dates[0] && dates[1]) {
                      const startDate = dates[0];
                      const endDate = dates[1];
                      setCustomDateRange([startDate, endDate]);
                      methods.setValue("dateRange", dates);

                      // Clear error message when date is selected
                      methods.clearErrors("dateRange");

                      // Check if the selected dates match any of our predefined ranges
                      const today = dayjs();
                      const daysDiff = endDate.diff(startDate, "day");

                      if (startDate.isSame(today, "day") && daysDiff === 6) {
                        setSelectedDateRange("7days");
                      } else if (
                        startDate.isSame(today, "day") &&
                        daysDiff === 14
                      ) {
                        setSelectedDateRange("15days");
                      } else if (
                        startDate.isSame(today, "day") &&
                        daysDiff === 29
                      ) {
                        setSelectedDateRange("30days");
                      } else if (
                        startDate.isSame(today, "day") &&
                        daysDiff === 44
                      ) {
                        setSelectedDateRange("45days");
                      } else {
                        // If dates don't match any predefined range, clear selection
                        setSelectedDateRange(null);
                      }
                      // Don't update filteredData here - only update when Find is clicked
                    } else {
                      setCustomDateRange(null);
                      methods.setValue("dateRange", null);
                      setSelectedDateRange(null); // Clear button selection when dates are cleared
                      // Don't update filteredData here - only update when Find is clicked
                    }
                  }}
                  style={{ width: "100%" }}
                />
                {isFormSubmitted && methods.formState.errors.dateRange && (
                  <p className="mandatory">This field is required</p>
                )}
                <div className="mt-2">
                  <div className="d-flex flex-wrap gap-2">
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        const newDateRange = [dayjs(), dayjs().add(7, "day")];
                        setCustomDateRange(newDateRange);
                        setSelectedDateRange("7days");
                        // Don't update filteredData here - only update when Find is clicked
                      }}
                      className="text-decoration-none text-primary small date-link-hover"
                      style={{
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        padding: "2px 6px",
                        borderRadius: "4px",
                        backgroundColor:
                          selectedDateRange === "7days"
                            ? "#e6f7ff"
                            : "transparent",
                        border:
                          selectedDateRange === "7days"
                            ? "1px solid #1890ff"
                            : "1px solid transparent",
                        color:
                          selectedDateRange === "7days" ? "#1890ff" : "#1890ff",
                        fontWeight:
                          selectedDateRange === "7days" ? "500" : "normal",
                      }}
                    >
                      Next 7 days
                    </a>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        const newDateRange = [dayjs(), dayjs().add(15, "day")];
                        setCustomDateRange(newDateRange);
                        setSelectedDateRange("15days");
                        // Don't update filteredData here - only update when Find is clicked
                      }}
                      className="text-decoration-none text-primary small date-link-hover"
                      style={{
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        padding: "2px 6px",
                        borderRadius: "4px",
                        backgroundColor:
                          selectedDateRange === "15days"
                            ? "#e6f7ff"
                            : "transparent",
                        border:
                          selectedDateRange === "15days"
                            ? "1px solid #1890ff"
                            : "1px solid transparent",
                        color:
                          selectedDateRange === "15days"
                            ? "#1890ff"
                            : "#1890ff",
                        fontWeight:
                          selectedDateRange === "15days" ? "500" : "normal",
                      }}
                    >
                      15 days
                    </a>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        const newDateRange = [dayjs(), dayjs().add(30, "day")];
                        setCustomDateRange(newDateRange);
                        setSelectedDateRange("30days");
                        // Don't update filteredData here - only update when Find is clicked
                      }}
                      className="text-decoration-none text-primary small date-link-hover"
                      style={{
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        padding: "2px 6px",
                        borderRadius: "4px",
                        backgroundColor:
                          selectedDateRange === "30days"
                            ? "#e6f7ff"
                            : "transparent",
                        border:
                          selectedDateRange === "30days"
                            ? "1px solid #1890ff"
                            : "1px solid transparent",
                        color:
                          selectedDateRange === "30days"
                            ? "#1890ff"
                            : "#1890ff",
                        fontWeight:
                          selectedDateRange === "30days" ? "500" : "normal",
                      }}
                    >
                      30 days
                    </a>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        const newDateRange = [dayjs(), dayjs().add(45, "day")];
                        setCustomDateRange(newDateRange);
                        setSelectedDateRange("45days");
                        // Don't update filteredData here - only update when Find is clicked
                      }}
                      className="text-decoration-none text-primary small date-link-hover"
                      style={{
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        padding: "2px 6px",
                        borderRadius: "4px",
                        backgroundColor:
                          selectedDateRange === "45days"
                            ? "#e6f7ff"
                            : "transparent",
                        border:
                          selectedDateRange === "45days"
                            ? "1px solid #1890ff"
                            : "1px solid transparent",
                        color:
                          selectedDateRange === "45days"
                            ? "#1890ff"
                            : "#1890ff",
                        fontWeight:
                          selectedDateRange === "45days" ? "500" : "normal",
                      }}
                    >
                      45 days
                    </a>
                  </div>
                </div>
              </div>

              <div key={"filters2"} className="mb-2 mt-0">
                <FormMultiSelect
                  name="phaseIds"
                  label="Phase"
                  placeholder="Select Phases"
                  options={phaseFilterData}
                  required={false}
                />
              </div>

              <div key={"filters3"} className="mt-0 mb-2">
                <FormMultiSelect
                  name="activityIds"
                  label="Activity"
                  placeholder="Select Activities"
                  options={activityFilterData}
                  required={false}
                />
              </div>

              <div key={"filters4"} className="mt-3 mb-2">
                <FormMultiSelect
                  name={`taskStatus`}
                  label={"Task Status"}
                  placeholder={"Select Task Status"}
                  options={taskStatusFilterData}
                  required={false}
                />
              </div>

              <div key={"filters5"} className="mt-0 mb-2">
                <FormSelect
                  name={`showOnlyShortageMaterials`}
                  label={"Show Only Shortage Materials"}
                  placeholder={"Select Option"}
                  options={[
                    { value: "yes", label: "Yes" },
                    { value: "no", label: "No" },
                  ]}
                  required={false}
                />
              </div>

              <div className="actions clearfix">
                <ul>
                  <li>
                    <Button color="primary" size="sm" type="submit">
                      Find
                    </Button>
                  </li>
                  <li>
                    <Button
                      size="sm"
                      color="primary"
                      className="btn-dim btn btn-secondary"
                      type="button"
                      onClick={() => {
                        methods.reset();
                        setFiltersModal(false);
                        setFilteredData({});
                        setCustomDateRange(null);
                        setSelectedDateRange(null);
                        setHasFiltersApplied(false);
                        // Clear all form fields to empty values and prevent default values from being set
                        methods.setValue("phaseIds", []);
                        methods.setValue("activityIds", []);
                        methods.setValue("taskStatus", []);
                        methods.setValue("showOnlyShortageMaterials", "");

                        // Clear form errors and reset submission state
                        methods.clearErrors();
                        setIsFormSubmitted(false);

                        // Set flag to prevent automatic default value setting
                        setHasResetBeenClicked(true);
                      }}
                    >
                      Cancel
                    </Button>
                  </li>
                </ul>
              </div>
            </form>
          </FormProvider>
        </div>
      </Drawer>

      {/* PR Generation Modal */}
      <Modal
        title="Generate Purchase Request"
        open={prModal}
        onCancel={() => {
          setPrModal(false);
          setPrFormData({
            requestedBy: "",
            deliveryAddress: "",
            prSequence: "",
            needByDate: "",
          });
          setPrError("");

          // Reset the filter data fetched flag so filter data can be fetched again
          setHasFilterDataBeenFetched(false);
        }}
        footer={null}
        width={600}
        maskClosable={false}
      >
        <div className="p-3">
          {prError && (
            <div className="alert alert-danger mb-3" role="alert">
              <i className="fas fa-exclamation-triangle me-2"></i>
              {prError}
            </div>
          )}
          <FormProvider {...methods}>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                if (isPrLoading) return;
                setPrError(""); // Clear previous errors
                createPurchaseRequest(displayRows).then((result) => {
                  if (result.success) {
                    Swal.fire({
                      title: "Success!",
                      text: `${
                        result.data?.response?.prSequence ||
                        result.data?.prSequence ||
                        "N/A"
                      } has been created successfully!`,
                      icon: "success",
                      confirmButtonText: "OK",
                      confirmButtonColor: "#28a745",
                    });
                    setPrModal(false);
                    setPrFormData({
                      requestedBy: "",
                      deliveryAddress: "",
                      prSequence: "",
                      needByDate: "",
                    });

                    // Close the preview drawer
                    setPreviewModal(false);

                    // Clear all input values to reset the table
                    setInputValues({});

                    // Refresh the main table data
                    fetchInventoryData();
                    // Clear all user input and display data to remove previous PR data
                    setDisplayRows([]);
                    setInputValues({});
                    // Reset the form to clear any filter selections
                    methods.reset();

                    // Reset the filter data fetched flag so filter data can be fetched again
                    setHasFilterDataBeenFetched(false);
                  } else {
                    Swal.fire({
                      title: "Error!",
                      text: result.error || "Failed to generate PR",
                      icon: "error",
                      confirmButtonText: "OK",
                      confirmButtonColor: "#dc3545",
                    });
                    setPrError(result.error || "Failed to generate PR");
                  }
                });
              }}
            >
              <div className="mb-3">
                <FormSelect
                  name="requestedBy"
                  label="Requested By"
                  placeholder="Select User"
                  options={siteUsers}
                  required={true}
                  disabled={siteUsers.length === 0}
                  onChange={(value) =>
                    setPrFormData((prev) => ({
                      ...prev,
                      requestedBy: value,
                    }))
                  }
                />
              </div>

              <div className="mb-3">
                <FormSelect
                  name="deliveryAddressId"
                  label="Delivery Address"
                  placeholder="Select Delivery Address"
                  options={siteAddresses}
                  required={true}
                  onChange={(value) =>
                    setPrFormData((prev) => ({
                      ...prev,
                      deliveryAddress: value,
                    }))
                  }
                />
              </div>

              <div className="mb-3">
                <FormDatePicker
                  name="needByDate"
                  label="Need By Date"
                  placeholder="Select need by date"
                  required={true}
                  minDate={new Date()}
                  defaultValue={
                    prFormData.needByDate ? dayjs(prFormData.needByDate) : null
                  }
                  onChange={(date) =>
                    setPrFormData((prev) => ({
                      ...prev,
                      needByDate: date ? dayjs(date).format("YYYY-MM-DD") : "",
                    }))
                  }
                />
              </div>

              {!sequenceData.includes("Purchase Request") && (
                <div className="mb-3">
                  <label className="form-label">
                    PR Sequence <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter PR sequence manually"
                    value={prFormData.prSequence}
                    onChange={(e) =>
                      setPrFormData((prev) => ({
                        ...prev,
                        prSequence: e.target.value,
                      }))
                    }
                    required
                  />
                </div>
              )}

              <div className="actions clearfix">
                <ul>
                  <li>
                    <Button
                      type="submit"
                      color="primary"
                      size="sm"
                      disabled={isPrLoading}
                    >
                      {isPrLoading ? (
                        <>
                          <Icon name="spinner" className="spin me-2" />
                          Generating...
                        </>
                      ) : (
                        "Generate PR"
                      )}
                    </Button>
                  </li>
                  <li>
                    <Button
                      type="button"
                      color="secondary"
                      size="sm"
                      onClick={() => {
                        setPrModal(false);
                        setPrFormData({
                          requestedBy: "",
                          deliveryAddress: "",
                          prSequence: "",
                          needByDate: "",
                        });
                        setPrError("");
                      }}
                    >
                      Cancel
                    </Button>
                  </li>
                </ul>
              </div>
            </form>
          </FormProvider>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default InventoryAnalysis;
